
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/produtores",
      function () {
        return require("private-next-pages/produtores/index.ts");
      }
    ]);
  